import script from "./TempK.vue?vue&type=script&lang=ts&setup=true"
export * from "./TempK.vue?vue&type=script&lang=ts&setup=true"

import "./TempK.vue?vue&type=style&index=0&id=b7918e62&lang=scss&scoped=true"

import exportComponent from "/apps/jenkins/workspace/client-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b7918e62"]])

export default __exports__